import { pages } from './pages'
import { main } from '@/lang/nl/main.ts'
import { errors } from '@/lang/nl/errors.ts'

export default {
  main,
  pages,
  errors,
}
